export const MAP_POPUP_TYPES = {
  STOP: 'stop',
  CLUSTER: 'cluster',
};
